import React from 'react'
import { Banner, Button } from '../ui'

export function InvitationBanner({ invitations = [], onApprove, onDecline }) {
  if (!invitations.length) return null

  return (
    <div
      data-testid="invitation-banner"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-2)',
        padding: 'var(--space-2) var(--space-3)',
        borderBottom: '1px solid var(--border)',
      }}
    >
      {invitations.map((inv) => {
        const name = inv.managerName || inv.managerEmail
        return (
          <Banner key={inv.managerId} tone="info">
            <span style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 'var(--space-2)' }}>
              <span style={{ flex: 1, minWidth: 0 }}>
                <strong>{name}</strong> wants to connect as your manager.
              </span>
              <span style={{ display: 'flex', gap: 'var(--space-1)' }}>
                <Button
                  size="sm"
                  variant="primary"
                  onClick={() => onApprove(inv.managerId)}
                  aria-label={`Approve invitation from ${name}`}
                >
                  Approve
                </Button>
                <Button
                  size="sm"
                  variant="secondary"
                  onClick={() => onDecline(inv.managerId)}
                  aria-label={`Decline invitation from ${name}`}
                >
                  Decline
                </Button>
              </span>
            </span>
          </Banner>
        )
      })}
    </div>
  )
}
